import { useMutation } from "@tanstack/react-query"
import { OEBackend } from "@/graphql"
import { useGraphQLClient } from "@/lib/blueprint-auth/client"
import { logger } from "@/lib/logger"

export const ExtractDataFromInvoiceMutation = OEBackend.graphql(`
    mutation ExtractDataFromInvoice($encodedPdf: String!) {
        extractDataFromInvoice(encodedPdf: $encodedPdf) {
            result {
                amountDueMonthly
                annualConsumption {
                    allDay
                    offPeak
                    peak
                }
                client {
                    civility
                    email
                    firstName
                    lastName
                }
                tariffOption
                invoiceIssueDate
                extractionUuid
            }
        }
    }
`)

export function useExtractDataFromInvoice() {
    const oeGraphQLClient = useGraphQLClient({ target: "oeBackend" })

    return useMutation({
        mutationKey: ["extractDataFromInvoice"],
        mutationFn: async (encodedPdf: string) => {
            const data = await oeGraphQLClient.request(ExtractDataFromInvoiceMutation, {
                encodedPdf,
            })

            return data.extractDataFromInvoice?.result
        },
        onError: () => {
            logger.error({
                error: new Error("Failed to extract invoice data"),
                meta: {
                    feature: "invoiceUpload",
                    source: "useExtractDataFromInvoice",
                },
            })
        },
    })
}
